import { render, staticRenderFns } from "./TransactionsStatistics.vue?vue&type=template&id=2d634588&"
import script from "./TransactionsStatistics.vue?vue&type=script&lang=js&"
export * from "./TransactionsStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports